var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"md":"12","mb":"0"}},[_c('b-alert',{attrs:{"show":"","dismissible":"","variant":"warning"}},[_vm._v(" "+_vm._s(_vm.$t( 'You can not change the layout of the book, because the new version with separate book parts is available' ))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }